var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"page_header"},[_c('fpHeader')],1),_c('div',{staticClass:"page_main"},[_c('router-view')],1),_c('fpFooter',{staticClass:"page_footer"}),_c('fpSideIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }